import logo from "./logo.png";
import hLogo from "./h-logo.png";
import logoClaim from "./logo-claim.png";
import shortedLogo from "./shorted-logo.png";

/** Contenido de marca (isotipo/logotipo) compartido por Logo, Isotipo y LoadingScreen. */
export const content = {
  fullLogo: {
    src: logo,
    alt: "AIJ AGRO — Siempre cerca del productor",
  },
  horizontalLogo: {
    src: hLogo,
    alt: "AIJ AGRO — Siempre cerca del productor",
  },
  claimLogo: {
    src: logoClaim,
    alt: "AIJ AGRO — Siempre cerca del productor",
  },
  isotipo: {
    src: shortedLogo,
    alt: "AIJ AGRO",
  },
};
